module.exports = __webpack_public_path__ + "img/wifi_signal_2_selected.7c158c7b.svg";